module.exports = __webpack_public_path__ + "static/media/DSC_0261.095766cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0261.jpg
// module id = 572
// module chunks = 0